import { defineComponent as _defineComponent } from 'vue';
import confirmationModal from '@/components/DeleteModal.vue';
import BulkImportDialog from '@/views/BulkImportDialog.vue';
import { computed, getCurrentInstance, nextTick, onMounted, reactive, ref, watch } from 'vue';
import { useActions, useGetters, useState } from 'vuex-composition-helpers';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FeedList',
    setup(__props) {
        const { find: fetchFeeds, remove, patch, create: createFeed } = useActions('feed', ['create', 'find', 'remove', 'patch']);
        const { create: enqueue } = useActions('queue-management', ['create']);
        const { find: findFeedsInStore } = useGetters('feed', ['find']);
        const { user } = useState('auth', ['user']);
        const { isFindPending: areFeedsLoading, isCreatePending: creatingFeed } = useState('feed', ['isFindPending', 'isCreatePending']);
        const page = ref(1);
        const perPage = ref(10);
        const sortBy = ref(null);
        const sortDesc = ref(false);
        const headers = [
            {
                text: "Name",
                align: "start",
                value: "name",
                sortable: true,
            },
            {
                text: "Created At",
                value: "createdAt",
                sortable: true
            },
            {
                text: "Status",
                value: "currentProgressData",
                sortable: true,
            },
            {
                text: "Actions",
                align: "end",
                value: "actions",
                sortable: true
            },
        ];
        const newFeedModal = ref(false);
        const feedData = reactive({
            url: '',
            name: '',
            type: 'general',
            isQueryExecutionChained: false
        });
        const params = computed(() => {
            const baseQuery = {
                $limit: perPage.value,
                $sort: {
                    createdAt: -1
                },
                $skip: (page.value - 1) * perPage.value
            };
            if (sortBy.value !== null) {
                // @ts-ignore
                baseQuery.$sort = { [sortBy.value]: sortDesc.value ? -1 : 1 };
            }
            return {
                query: baseQuery
            };
        });
        const companyModalBtnLoading = computed(() => {
            return creatingFeed.value;
        });
        const feeds = computed(() => {
            return findFeedsInStore.value(params.value).data;
        });
        async function saveRecord() {
            let promise, successMessage;
            const feedItem = {
                name: feedData.name,
                fields: [],
                url: feedData.url,
                type: feedData.type,
                isQueryExecutionChained: feedData.isQueryExecutionChained
            };
            if (feedData._id) {
                promise = patch([feedData._id, feedItem, {}]);
                successMessage = 'Record updated';
            }
            else {
                promise = createFeed(feedItem);
                successMessage = 'Record created';
            }
            promise.then(() => {
                instance?.$toasted.global.success({
                    message: successMessage
                });
                newFeedModal.value = false;
            }).catch((errors) => {
                instance?.$toasted.global.error({
                    message: errors.message
                });
            });
            const feed = await promise;
            if (feed.type === 'general')
                enqueue({
                    feedId: feed._id,
                    task: 'import'
                });
            else
                enqueue({
                    feedId: feed._id,
                    task: 'full-workflow',
                });
        }
        function openNewFeedModal(feed) {
            //console.log('Opening modal with', feed)
            feedData.url = feed?.url ?? '';
            feedData.name = feed?.name;
            feedData._id = feed?._id;
            feedData.type = feed?.type ?? 'general';
            nextTick(() => newFeedModal.value = true);
        }
        const instance = getCurrentInstance()?.proxy;
        function deleteItem(item) {
            remove(item._id).then(() => {
                // @ts-ignore
                instance?.$toasted.global.success({
                    message: 'Record removed'
                });
            });
        }
        const totalfeedsCount = ref(0);
        watch(params, () => {
            fetchFeeds(params.value);
        }, { immediate: true });
        onMounted(() => {
            fetchFeeds({ query: { $limit: 0 } }).then((response) => {
                totalfeedsCount.value = response.total;
            });
        });
        const importDialogState = ref(false);
        return { __sfc: true, fetchFeeds, remove, patch, createFeed, enqueue, findFeedsInStore, user, areFeedsLoading, creatingFeed, page, perPage, sortBy, sortDesc, headers, newFeedModal, feedData, params, companyModalBtnLoading, feeds, saveRecord, openNewFeedModal, instance, deleteItem, totalfeedsCount, importDialogState, confirmationModal, BulkImportDialog };
    }
});
